<template>
  <fieldset class="account__form-section account__form-section--wide">
    <legend class="account__form-section-title">{{ formSection }}</legend>
    <div class="input-group__directions layout--text-button-wrap">
      <div class="layout--margin-bottom-sm">
        You are currently on the
        <strong>{{ subscription.discriminator }} plan.</strong>
      </div>
      <router-link
        :to="{ name: 'change plan' }"
        class="button ayout--margin-bottom-sm"
        >Change Plan</router-link
      >
    </div>
    <h3 class="text-size-sm  layout--margin-bottom-sm">Plan Details</h3>
    <dl class="layout--plain-list">
      <PlanListItem
        v-for="(detail, index) in currentPlanDetails"
        :name="detail.description"
        :value="detail.value"
        :index="index"
        :key="index"
      />
    </dl>
  </fieldset>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { getBillingCycleDescription } from "../../../helpers/helpers";

import PlanListItem from "./PlanListItem";

const formSection = "Your Plan";

export default {
  name: "YourPlan",
  components: {
    PlanListItem,
  },
  mounted: function() {
    if (this.sortedSubscriptionOptions.length === 0) {
      this.getSubscriptionOptions();
    }
  },
  data() {
    return {
      formSection,
      planName: "Bootstrap",
    };
  },
  methods: {
    ...mapActions("account", ["getSubscriptionOptions"]),
  },
  computed: {
    ...mapGetters("account", ["subscription", "sortedSubscriptionOptions"]),
    currentSubscription: function() {
      if (
        this.sortedSubscriptionOptions.length > 0 &&
        typeof this.subscription.subscriptionType !== "undefined"
      ) {
        return this.sortedSubscriptionOptions.find(
          s =>
            s.subscriptionType === parseInt(this.subscription.subscriptionType)
        );
      }
      return {
        annualPriceLabel: "",
        monthlyCreditsFormatted: "",
        monthlyPriceLabel: "",
        hasBranding: true,
        hasDynamicLocal: false,
        hasRollover: false,
        costPerCreditLabel: "unavailable",
      };
    },
    currentPlanDetails: function() {
      const planDetails = [
        {
          description: "views per month",
          value: this.currentSubscription.monthlyCreditsFormatted,
        },
        {
          description: "branding removed",
          value: this.currentSubscription.hasBranding ? "no" : "yes",
        },
        {
          description: "dynamic language",
          value: this.currentSubscription.hasDynamicLocal ? "yes" : "no",
        },
        {
          description: "credits rollover",
          value: this.currentSubscription.hasRollover ? "yes" : "no",
        },
        {
          description: "additional views",
          value: this.currentSubscription.costPerCreditLabel,
        },
        { description: "number of timers", value: "unlimited" },
      ];
      const billingCycleDescription = getBillingCycleDescription(
        this.subscription.billingCycle
      );
      if (billingCycleDescription === "monthly") {
        planDetails.splice(0, 0, {
          description: "cost per month",
          value: this.currentSubscription.monthlyPriceLabel,
        });
      }
      if (billingCycleDescription === "annually") {
        planDetails.splice(0, 0, {
          description: "cost per year",
          value: this.currentSubscription.annualPriceLabel,
        });
      }
      return planDetails;
    },
  },
};
</script>

<style></style>
